// extracted by mini-css-extract-plugin
export default {"copyright":"Footer_copyright__VXlzV","made-by":"Footer_made-by__iwNDv","made-by-text":"Footer_made-by-text__Tke2H"};